const $ = jQuery;

class MobileNav {
	init() {
		this.setScrollBarWidth();
		$(document).on('click', '[data-toggle-menu]', this.toggleMobileMenu);
		$(document).on('click', '[data-toggle-submenu]', this.toggleMobileMenuSubnav);
	}

	toggleMobileMenu(e) {
		e.preventDefault();
		if ($('body').is('.open-nav')) {
			$('body').removeClass('open-nav');
			$('[data-toggle-menu]').attr('aria-expanded', 'false').attr('title', 'Open main menu');
		} else {
			$('body').addClass('open-nav');
			$('[data-toggle-menu]').attr('aria-expanded', 'true').attr('title', 'Close main menu');
		}
	}

	toggleMobileMenuSubnav(e) {
		e.preventDefault();
		const $parent = $(this).closest('li');
		const $submenu = $(this).siblings('ul');
		if ($submenu.is(':visible')) {
			$submenu.slideUp('slow');
			$parent.attr('aria-expanded', 'false').attr('title', 'Open main menu');
		} else {
			$submenu.slideDown(
				{
					start() {
						$(this).css({
							display: 'flex',
						});
					},
				},
				'slow'
			);
			$parent.attr('aria-expanded', 'true').attr('title', 'Close main menu');
		}
	}

	getScrollBarWidth() {
		// https://stackoverflow.com/questions/13382516/getting-scroll-bar-width-using-javascript
		const outer = document.createElement('div');
		outer.style.visibility = 'hidden';
		outer.style.overflow = 'scroll';
		outer.style.msOverflowStyle = 'scrollbar';
		document.body.appendChild(outer);
		const inner = document.createElement('div');
		outer.appendChild(inner);
		const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
		outer.parentNode.removeChild(outer);
		return scrollbarWidth;
	}

	setScrollBarWidth() {
		// Set CSS variable
		const root = document.querySelector(':root');
		root.style.setProperty('--scrollbar-width', this.getScrollBarWidth() + 'px');
	}
}

export default new MobileNav();
